import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PostCard from '../components/PostCard';
import { postApi } from '../services/postApi';
import './Post.css';

const Post = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const highlightCommentId = searchParams.get('highlight_comment');
  const { t } = useTranslation();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPost = async () => {
      try {
        setLoading(true);
        const response = await postApi.getPost(id);
        setPost(response.data);

        // Load comments for this post
        if (response.data?.id) {
          try {
            const commentsResponse = await postApi.getBatchComments([response.data.id]);
            if (commentsResponse.data?.[response.data.id]) {
              setComments(commentsResponse.data[response.data.id]);
            }
          } catch (err) {
            console.error('Error loading comments:', err);
          }
        }
      } catch (err) {
        console.error('Failed to load post:', err);
        setError(t('common.error'));
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadPost();
    }
  }, [id, t]);

  if (loading) {
    return (
      <div className="post-page">
        <div className="post-loading">{t('common.loading')}</div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="post-page">
        <div className="post-error">{error || 'Post not found'}</div>
      </div>
    );
  }

  return (
    <div className="post-page">
      <PostCard post={post} initialComments={comments} highlightCommentId={highlightCommentId} />
    </div>
  );
};

export default Post;
